<template><span>{{ Rub }}<template v-if="Kop.length">.<span style="font-size: 80%">{{ Kop }}</span></template></span></template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	name: 'moneyComponent',
	props: ['value'],
	data() {
		return {
			Parts: null
		}
	},
	created() {
		this.Parts = String(this.value).split('.')
	},
	computed: {
		// вычисляем рубли
		Rub() {
			if (this.Parts[0]) return this.Parts[0]
			return ''
		},
		// вычисляем копейки
		Kop() {
			if (this.Parts[1]) return this.Parts[1]
			return ''
		}
	},
	watch: {
		value(val) {
			this.Parts = String(val).split('.')
		}
	}
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// money.vue?a63b9788